export const DARK_FORM_STYLES = {}

export const SUBMIT_BUTTON_COLOR = '#5B9DFF';
export const SUBMIT_BUTTON_COLOR_LIGHT_THEME = '';
export const SUBMIT_BUTTON_COLOR_DARK_THEME = '';
